"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const ElementBaseConfig_1 = require("../../../../../config/ElementBaseConfig");
function StorageDetails(props) {
    return (react_1.default.createElement("div", { className: "flex-row jc-sb" },
        props.credential.sertifierCredential ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { style: {
                        maxWidth: "400px",
                    } }, (0, ElementBaseConfig_1.getElementkitConfig)().sertifierReplacementString) },
                react_1.default.createElement("img", { id: `sertifier-tooltip-${props.credential.sertifierCredential.id}`, src: (0, ElementBaseConfig_1.getElementkitConfig)()
                        .credentialSertifierIssuerLogoReplacementUrl, alt: `Sertifier Logo`, width: 26, height: 26 })))) : null,
        props.credential.velocityCredential ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "top", overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { style: {
                        maxWidth: "400px",
                    } }, "Velocity") },
                react_1.default.createElement("img", { id: `velocity-credential-${props.credential.velocityCredential.id}`, src: (0, ElementBaseConfig_1.getElementkitConfig)().credentialVelocityIssuerLogoReplacementUrl, alt: `Velocity Logo`, width: 26, height: 26 })))) : null));
}
exports.default = StorageDetails;
